import React from "react";
import { AlertTriangle } from "lucide-react";
import { useFeatureFlags } from "./FeatureFlagsContext";
import { getJwtRole } from "../service/AuthService";
import { admin } from "../constants/Constants";
import UnderConstruction from "./UnderConstruction";

/**
 * Wraps a route element (or any subtree) and hides it behind an "Under
 * Construction" screen when an admin has disabled that section.
 *
 *  - enabled (or flags still loading / unknown): render children normally.
 *  - disabled + admin: still render children, with a fixed warning badge noting
 *    the section is hidden from users (so it can be fixed/verified in prod).
 *  - disabled + non-admin: render <UnderConstruction>.
 */
export default function FeatureGate({ feature, children, variant = "app" }) {
    const { isEnabled } = useFeatureFlags();

    if (isEnabled(feature)) {
        return children;
    }

    const isAdmin = getJwtRole() === admin;
    if (!isAdmin) {
        return <UnderConstruction variant={variant} />;
    }

    return (
        <>
            {children}
            <div style={{
                position: "fixed", left: 16, bottom: 16, zIndex: 3000,
                display: "flex", alignItems: "center", gap: 8,
                padding: "8px 14px", borderRadius: 10,
                background: "var(--brand)", color: "#fff",
                fontSize: 12.5, fontWeight: 500,
                boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
                pointerEvents: "none", maxWidth: "calc(100vw - 32px)",
            }}>
                <AlertTriangle size={15} color="#f5c451" style={{ flexShrink: 0 }} />
                Under construction — hidden from users
            </div>
        </>
    );
}
